import { componentTypes } from '@white-nl/instantsearch-components';

export default function Stats({ results, statsSettings }: componentTypes.StatsProps) {
  const translationKey = statsSettings.translations?.resultsFound
    || '{qty, plural, =1{1 result} other{# results}}';

  // eslint-disable-next-line no-underscore-dangle
  const isLoading = results.__isArtificial || false;

  if (isLoading) {
    return null;
  }

  return Craft.t(
    'catalog',
    translationKey,
    { qty: results.nbHits },
  );
}
